import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { EcosystemSlider } from 'trellis-ecosystem';
import { CollectionCard } from '../../collections/components/CollectionCard';
import { Subscreens } from '../../constants/usage';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { SUGGESTED_FILTERS } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export function SuggestedFilters() {
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackCollectionCardClicked = (filter, index) => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'filter card clicked',
      category: filter.slug,
      itemIndex: index,
      subscreen: Subscreens.SUGGESTED_FILTERS
    }));
  };
  const trackSliderButtonClicked = direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggested filter section ${direction} arrow clicked`,
      // Hardcoded index based on figma design layout
      itemIndex: 2,
      subscreen: Subscreens.SUGGESTED_FILTERS
    }));
  };
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    maxInlineSize: "100%",
    children: /*#__PURE__*/_jsx(EcosystemSlider, {
      cardWidth: 625,
      gradientColor: "fill-surface-recessed",
      onScrollButtonClick: trackSliderButtonClicked
      // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
      ,
      scrollButtonTop: "43.5%",
      title: unescapedText('marketplaceStorefront.suggestedFilters.title'),
      description: unescapedText('marketplaceStorefront.suggestedFilters.description'),
      children: SUGGESTED_FILTERS.map((filter, index) => /*#__PURE__*/_jsx(CollectionCard, {
        buttonText: filter.buttonText,
        description: filter.description,
        href: `solutions${filter.slug}`,
        name: filter.name,
        onClick: () => {
          trackCollectionCardClicked(filter, index);
          scrollToTop();
        },
        slug: filter.slug
      }, filter.slug))
    })
  });
}